import { createFileRoute } from '@tanstack/react-router';
import { CapabilityTier } from '@signalvote/shared';
import { requireCapability } from '@/lib/routeGuards';
import { FollowUpSettingsEditor } from '@/components/fundraising';

// The Fundraiser's follow-up wording and donation link. Fundraising:Manage — the API refuses a write
// from a Caller at Do, and this keeps them off a page they can't save.
export const Route = createFileRoute('/admin/fundraising/follow-ups')({
  beforeLoad: ({ context }) => {
    requireCapability(context, 'Fundraising', CapabilityTier.Manage, '/admin/fundraising/follow-ups');
  },
  component: FollowUpSettingsEditor,
});
